import React from 'react';
import { Helmet } from 'react-helmet-async'; 

/**
 * Head component dynamically sets the document title and meta description for SEO.
 * Assumes the application is wrapped in <HelmetProvider>.
 *
 * @param {string} title - The specific title for the current page (e.g., "About PDF-Play | ...").
 * @param {string} description - The meta description for search engines.
 */
function Head({ title, description }) {
    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
        </Helmet>
    );
}

export default Head;